export default __webpack_public_path__ + "static/media/pgmico(39).767f2daa.png";